(function () {
  function formatTitle() {
    const titles = document.querySelectorAll('[data-photoshoot-title], [data-lookbook-title]');
    titles.forEach(el => {
      el.innerHTML = el.innerHTML.replace(/(\d+)/g, '<span class="new-product-information__title-number">$1</span>');
    });
  }
  

  function initVideos() {
    const videoWrapper = document.querySelector('[data-video-wrapper]');
    if (!videoWrapper) return;

    document.querySelectorAll('[data-video-overlay]').forEach((overlay) => {
      if (overlay.dataset.ready) return;

      const video = videoWrapper?.querySelector('video') || null;
      if (!video) return;

      overlay.dataset.ready = true;

      const showOverlay = () => {
        overlay.classList.remove('new-product-information__video-overlay--hidden');
        video.controls = false;
      };

      const hideOverlay = () => {
        overlay.classList.add('new-product-information__video-overlay--hidden');
        video.controls = true;
      };

      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        hideOverlay();
        video.play().catch(() => {});
      });

      video.addEventListener('pause', showOverlay);
      video.addEventListener('play', hideOverlay);
      video.addEventListener('ended', showOverlay);
    });
  }

  function init() {
    formatTitle();
    initVideos();
    setTimeout(initVideos, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', initVideos);
})();

